import { c as _c } from "react/compiler-runtime";
import IconAppstoreMobile from '@/assets/icons/bigIcons/app-store.svg';
import { Link } from '@/components/links';
import { EXTERNAL_LINKS } from '@/constants/links';
import useMediaQuery from '@/hooks/useMediaQuery';
import { getMediaQuery } from '@/styles/sizes';
import { AppstoreButtonProps } from './../types';
import { useTranslation } from 'react-i18next';
import { ClientGate } from '@/components/ClientGate';
import React from 'react';
import Image from 'next/image';
function Icon(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getMediaQuery("xl");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isDesktop = useMediaQuery(t0);
  if (!isDesktop && props.mobileVariant !== "full") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IconAppstoreMobile />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src={`/images/buttons/${process.env.NEXT_PUBLIC_LANGUAGE}/app-store-dark.svg`} alt="App Store" width={192} height={56} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function AppstoreButton(props) {
  const $ = _c(14);
  const {
    t
  } = useTranslation("core");
  let t0;
  if ($[0] !== t) {
    t0 = t("link.appStore");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = EXTERNAL_LINKS();
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = t1.appStore;
  let t3;
  if ($[3] !== t) {
    t3 = t("link.appStore");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span className="sr-only">{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image src={`/images/buttons/${process.env.NEXT_PUBLIC_LANGUAGE}/app-store-dark.svg`} alt="App Store" width={192} height={56} />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props) {
    t6 = <ClientGate fallback={t5}><Icon {...props} /></ClientGate>;
    $[8] = props;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t0 || $[11] !== t4 || $[12] !== t6) {
    t7 = <Link aria-label={t0} analyticsParam="appStore" testId="appStore" to={t2}>{t4}{t6}</Link>;
    $[10] = t0;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}